import clsx from "clsx";
import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import Button from "@material-ui/core/Button";

import SummaryInfo from "components/SummaryInfo";
import { useAppSelector } from "hooks/redux/useAppSelector";

import useStyles from "./styles";

interface IProps {
  horseData: racehorse360.IHorseShortInfo;
  onHorseUnselect: () => void;
  selectedFacilityId: string;
  onSetSelectedFacility: (facilityId: string) => void;
}

const HorseDetails = (props: IProps) => {
  const {
    horseData,
    onHorseUnselect,
    selectedFacilityId,
    onSetSelectedFacility
  } = props;

  const classes = useStyles();
  const facilities = useAppSelector(state => state.facilities.facilities);

  const handleFacilitySelect = e => {
    onSetSelectedFacility(e.currentTarget.value);
  };

  const facilityItems = facilities.map(facility => (
    <Button
      key={facility.id}
      className={clsx(classes.button, {
        [classes.buttonActive]: facility.id === selectedFacilityId
      })}
      variant="outlined"
      value={facility.id}
      onClick={handleFacilitySelect}
    >
      {facility.name.toLowerCase()}
    </Button>
  ));

  return (
    <>
      <SummaryInfo
        variant={"paper"}
        classes={{
          root: classes.horseSummaryRoot,
          info: classes.horseSummaryInfo
        }}
        selected={true}
        mainTitle={horseData.horseName}
        contentNumber={horseData.horseRegistrationNumber}
        contentText={horseData.trainerName}
        onItemUnselect={onHorseUnselect}
      />

      <div>
        <div className={classes.trackSelectionTitle}>Select A Track</div>
        <div className={classes.trackSelectionContent}>{facilityItems}</div>
      </div>
    </>
  );
};

export default React.memo(HorseDetails);
